module.exports = __webpack_public_path__ + "static/media/sualti2020.27dc2974.png";